var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsuranceCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 89,
    viewBox: "0 0 114 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1057_10620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.4286,
    y: 34.8564,
    width: 76.5714,
    height: 48.2857,
    rx: 5,
    fill: "#F8F8F8",
    stroke: "#2C2828",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2783 51.2087C93.8351 53.343 92.5589 55.5253 90.4258 56.0867L34.5715 70.7852L34.5715 56.6423L76.997 37.358C77.5168 37.1217 78.0812 36.9994 78.6522 36.9994L89.5715 36.9994L93.2783 51.2087Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 48H99",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 57.4277H99",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 69.999H75.4286",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4286 69.999H99",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.22351,
    y: 21.7688,
    width: 76.5714,
    height: 48.2857,
    rx: 5,
    transform: "rotate(-14.9 1.22351 21.7688)",
    fill: "#F8F8F8",
    stroke: "#2C2828",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1635,
    y: 29.9739,
    width: 26.2857,
    height: 26.2857,
    rx: 1,
    transform: "rotate(-14.9 13.1635 29.9739)",
    fill: "#D0D0D0",
    stroke: "#2C2828",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.8398,
    cy: 37.7774,
    r: 5.53572,
    transform: "rotate(-14.9 28.8398 37.7774)",
    fill: "#F8F8F8",
    stroke: "#2C2828",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8217 53.4929C22.4644 48.773 25.505 44.3193 30.2447 43.0581C34.9844 41.797 39.8363 44.1507 41.8719 48.424C42.1035 48.9102 41.8245 49.5768 41.112 49.7664L24.1482 54.2801C23.4357 54.4697 22.8623 54.0298 22.8217 53.4929Z",
    fill: "#F8F8F8",
    stroke: "#2C2828",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4737 22.25L67.9747 16.7951",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2921 29.083L69.793 23.6281",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3123 36.6758L63.4611 33.4433",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1057_10620",
    x: 1.33957,
    y: 2.19629,
    width: 112.66,
    height: 85.9463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1057_10620"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1057_10620",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceCard);
export default __webpack_public_path__ + "static/media/insurance-card.995ade3c3076ee8358a185d9893c0fba.svg";
export { ForwardRef as ReactComponent };